import React, { FC, useState, useRef, useEffect } from 'react'
import Modal from 'react-modal'
import { usePromiseTracker } from 'react-promise-tracker'
import { trackPromise } from 'react-promise-tracker'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import { getUserWeeklyActivity } from '../../../Api/backendApi'

import {
  modalStyles,
  PopupContainer,
  Row,
  Column,
  Image,
  Text,
  CalendarTile,
  ActiveDayCompletedIcon,
  Button,
} from '../../VideoScreen/styles/VideoScreenStyles'

import Loader from '../../Loader/Loader'

import trophyIcon from '../../../assets/player/trophyIcon.webp'

interface NotCompletedLockedTrainingPopupProps {
  isNotCompletedLockedTrainingPopupOpen: boolean
  toggleNotCompletedLockedTrainingPopupOpen: Function
  isLockedVideoToday: boolean
  todayLockedVideo: any
  albumId: string
}

const NotCompletedLockedTrainingPopup: FC<NotCompletedLockedTrainingPopupProps> =
  ({
    isNotCompletedLockedTrainingPopupOpen,
    toggleNotCompletedLockedTrainingPopupOpen,
    todayLockedVideo,
    isLockedVideoToday,
    albumId,
  }) => {
    const [shouldPopupOpen, setShouldPopupOpen] = useState(false)
    const NotCompletedLockedTrainingPopup = useRef(null)
    Modal.setAppElement('#root')

    useEffect(() => {
      setShouldPopupOpen(
        isLockedVideoToday &&
          !todayLockedVideo.is_watched &&
          albumId == todayLockedVideo.album.album_id
      )
    }, [albumId, isLockedVideoToday, todayLockedVideo])

    return (
      <Modal
        ref={NotCompletedLockedTrainingPopup}
        isOpen={shouldPopupOpen}
        onRequestClose={() => setShouldPopupOpen(false)}
        style={modalStyles}
      >
        <PopupContainer>
          <Row margin={`5px 0`}>
            <Text
              width={'100%'}
              textAlign={'center'}
              fontWeight={'bold'}
              fontSize={isMobile ? 50 : 40}
              display={'inline-block'}
            >
              Trening nr {todayLockedVideo && todayLockedVideo.video_order_id}{' '}
              wciąż przed Tobą!
            </Text>
          </Row>

          <Row margin={`10% 0 0 0`}>
            <Text
              width={'100%'}
              textAlign={'center'}
              fontWeight={'normal'}
              fontSize={isMobile ? 28 : 28}
              display={'inline-block'}
            >
              Zanim go nie ukończysz nie przejdziesz do kolejnego treningu.
            </Text>
          </Row>

          <Row
            margin={`${isMobile ? '10vh' : '10vh'} 0  ${
              isMobile ? '4vh' : '30px'
            } 0`}
          >
            <Button width={'60%'} onClick={() => setShouldPopupOpen(false)}>
              Idę odpocząć
            </Button>
          </Row>
        </PopupContainer>
      </Modal>
    )
  }

export default NotCompletedLockedTrainingPopup
